import { render, staticRenderFns } from "./diagnose.vue?vue&type=template&id=8d1b7558&scoped=true"
import script from "./diagnose.vue?vue&type=script&lang=js"
export * from "./diagnose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1b7558",
  null
  
)

export default component.exports